import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Wallet, BrainCircuit } from 'lucide-react';
const pillars = [{
  icon: Wallet,
  title: 'Presupuesto de Supervivencia',
  desc: "No es 'el presupuesto ideal'. Es el mínimo realista que sí se cumple y que te evita improvisar."
}, {
  icon: ShieldAlert,
  title: 'Reglas de Fricción',
  desc: 'Barreras intencionales para que comprar no sea automático. Si tu tarjeta está a un clic… no es una prueba de carácter. Es una trampa.'
}, {
  icon: BrainCircuit,
  title: 'Mapa de Gatillos',
  desc: "Vas a identificar tu cadena real: emoción → pensamiento → compra, para desarmarla antes de que se vuelva 'ya qué'."
}];
export function MethodSection() {
  return <section className="py-24 px-6 bg-bg-secondary" data-id="element-112">
      <div className="max-w-6xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-114">
          <h2 className="text-4xl md:text-5xl font-serif text-text-primary mb-6" data-id="element-115">
            El método: 3 piezas
          </h2>
          <p className="text-xl text-text-secondary" data-id="element-116">(y por eso funciona)</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-117">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-bg-main p-8 rounded-2xl border border-white/5 hover:border-brand-gold/30 transition-colors group" data-id="element-118">
              <div className="w-14 h-14 bg-brand-gold/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-brand-gold/20 transition-colors" data-id="element-119">
                <pillar.icon className="w-7 h-7 text-brand-gold" data-id="element-120" />
              </div>
              <h3 className="text-2xl font-serif text-text-primary mb-4" data-id="element-121">
                {index + 1}. {pillar.title}
              </h3>
              <p className="text-text-secondary leading-relaxed" data-id="element-122">
                {pillar.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}